import { getCurrentInstance, watch } from 'vue'

const openModals = new Set<object>()
export const isModalOpen = () => openModals.size > 0

// Global PrimeVue Dialog hooks cover every modal, including ConfirmDialog's inner Dialog.
export const modalTrackingHooks = {
  onMounted() {
    const instance = getCurrentInstance()!
    watch(
      () => instance.props.visible === true && instance.props.modal === true,
      (visible) => {
        if (visible) openModals.add(instance)
        else openModals.delete(instance)
      },
      { immediate: true, flush: 'sync' }
    )
  },
  onUnmounted() {
    openModals.delete(getCurrentInstance()!)
  }
}
